import { useLocation } from "react-router-dom";
import SponsorAds from "./SponsorAds";
import { useEffect, useState } from 'react';
import API from '../api/axios';

export default function RightSidebar() {
  const location = useLocation();
  const [sidebarAds, setSidebarAds] = useState([]);
  const [helpfulTips, setHelpfulTips] = useState();

  const isSubmitPage = location.pathname === "/submit-project";
  const isEditPage = /^\/edit-project\/\d+$/.test(location.pathname);

  const shouldHideSidebar = isSubmitPage || isEditPage;

  const rightAds = [
    { image: "/ads/3-200x250.jpg", link: "https://example.com/ad3" },
    { image: "/ads/4-200x250.jpg", link: "https://example.com/ad4" },
  ];

  
  useEffect(() => {
    API.get("/settings/")
      .then((res) => {
        const tipsSetting = res.data.find(item => item.key === "helpful_tips");
        if (tipsSetting) {
          setHelpfulTips(tipsSetting.value);
        }
      })
      .catch((err) => {
        console.error("Error fetching settings:", err);
      });
  }, []);
  
  useEffect(() => {
    API.get("/ad-slots/")
      .then((res) => {
        if (res.data?.success && Array.isArray(res.data.data)) {
          const filteredAds = res.data.data
            .filter(
              (ad) =>
                (ad.placement === "sidebar" || ad.placement === "rightsidebar") &&
                ad.status === "active"
            )
            .map((ad) => ({
              type: ad.type,
              image: ad.image_url,
              link: ad.target_url || "#",
              embed_code: ad.embed_code,
            }));

          setSidebarAds(filteredAds);
        }
      })
      .catch((err) => console.error("Ad slots fetch failed:", err));
  }, []);

  return (
    <div className="rightSidebar">
    <div className="wrapper">
      {shouldHideSidebar ? null : (
          helpfulTips && (
            <div className="card help-box mb-10" style={{ marginBottom: "10px" }}>
              <h5 className="mb-2">Helpful Tips</h5>
              {/* Render HTML safely */}
              <div dangerouslySetInnerHTML={{ __html: helpfulTips }} />
            </div>
          )
      )}

      {/* Sponsor Ads */}
      <SponsorAds ads={sidebarAds} />
    </div>
    </div>
  );
}
